import { Theme, webLightTheme } from "@fluentui/react-components";

const brandBlue = {
  soft: "#EAF3FF", // --color-blue-3
  base: "#1667DD", // --color-blue-9
  hover: "#0058CD", // --color-blue-10
  stroke: "#9CC2FC", // --color-blue-7
  pressed: "#0F3063", // --color-blue-12
};

export const appTheme: Theme = {
  ...webLightTheme,
  colorBrandBackground: brandBlue.base,
  colorBrandBackgroundHover: brandBlue.hover,
  colorBrandBackgroundPressed: brandBlue.pressed,
  colorBrandBackgroundSelected: brandBlue.hover,
  colorBrandForeground1: brandBlue.base,
  colorBrandForeground2: brandBlue.hover,
  colorBrandForegroundLink: brandBlue.base,
  colorBrandForegroundLinkHover: brandBlue.hover,
  colorBrandForegroundLinkPressed: brandBlue.pressed,
  colorBrandStroke1: brandBlue.base,
  colorBrandStroke2: brandBlue.stroke,
  colorCompoundBrandBackground: brandBlue.base,
  colorCompoundBrandBackgroundHover: brandBlue.hover,
  colorCompoundBrandBackgroundPressed: brandBlue.pressed,
  colorCompoundBrandStroke: brandBlue.base,
  colorCompoundBrandStrokeHover: brandBlue.hover,
  colorCompoundBrandStrokePressed: brandBlue.pressed,
};

export const brandSoftBackground = brandBlue.soft;
